<template>
  <div class="brdpckr">
    <div
      class="brdpckr_cards"
      :class="{ 'no-events': disabled }"
    >
      <div class="d-flex">
        <PokerCard
          v-for="(card, idx) in visibleCards"
          :key="idx"
          :hasAnimation="true"
          class="poker-card_selectable brdpckr_cards_card"
          :data-tst="`${tstPrefix}_chosen_${lockedCards.includes(card) ? 'locked_' : ''}${card}`"
          :size="screen_max440 ? 'semi-large' : cardSize"
          :card="card"
          :isLocked="lockedCards.includes(card)"
          :cardVisual="cardVisual"
          @click.stop="toogle(card)"
        >
        </PokerCard>
      </div>

      <div
        v-if="hasClearCards && !l_cards.every(i => i.includes('E'))"
        class="brdpckr_clear mdi mdi-close icon_btn clr-grey text-semi-large my-auto pa-1 csst csst_nm text-nowrap anim-fade-in"
        @click.stop="clear"
        @mouseenter="e => fl_positionTooltip(e, { placement: 'top' })"
      >
        <div
          class="csst_content clr-white"
          style="position: fixed"
          v-html="$t('common.clear_board')"
        ></div>
      </div>
      <div
        v-if="hasRandomize"
        data-tst="btn_randomize_board"
        class="brdpckr_randomize gw_btn csst csst_nm"
        @mouseenter="e => fl_positionTooltip(e, { placement: 'top-start' })"
        @click="randomize"
      >
        <i class="text-semi-large mdi mdi-shuffle-variant"></i>
        <div
          class="csst_content"
          style="position: fixed; max-width: 22rem"
        >
          {{ $t('tooltips.select_random_card') }}
        </div>
      </div>
    </div>
    <div
      class="brdpckr_cards-rows position-relative"
      style="min-height: var(--min-height-cardbox, 0)"
    >
      <slot name="cardsrows"></slot>
      <div
        v-for="(cardRow, idx) in cardRows"
        :key="idx"
        :class="{ opacity_2: disabled }"
        class="brdpckr_cards-rows_row"
      >
        <PokerCard
          v-for="card in cardRow"
          :key="card.id"
          :hasAnimation="false"
          :size="screen_max440 ? 'semi-large' : cardSize"
          :cardVisual="cardVisual"
          class="brdpckr_cards-rows_row_card"
          :class="{ 'poker-card_selectable': visible > selected }"
          :data-tst="`${tstPrefix}_available_${card.selected ? 'selected_' : ''}${
            card.locked ? 'locked_' : ''
          }${card.id}`"
          :selected="card.selected"
          :isLocked="card.locked"
          :card="card.id"
          @click.stop="toogle(card.id)"
        ></PokerCard>
      </div>
    </div>

    <div
      v-if="isDev"
      class="f-column"
      style="position: absolute; right: 0; top: 0; gap: 0.25rem; z-index: 4"
    >
      <div
        class="gw_btn"
        @click="emitUpdate(['Qs', 'Ts', '7h', 'E4', 'E5'], 'randomized', 'force')"
      >
        QsTs7h
      </div>
      <div
        class="gw_btn"
        @click="emitUpdate(['Qs', 'Ts', '8h', 'E4', 'E5'], 'randomized', 'force')"
      >
        QsTs8h
      </div>
    </div>
  </div>
</template>

<script>
import PokerCard from '@/components/Poker/PokerCard/PokerCard'
import { getCardsFromStr, getValidBoard, getCardRows, getAllCards } from '@/helpers/cards'
import { getRandomOptions } from '@/helpers/helpers'
import float_mix from '@/mixins/float_mix'

export default {
  name: 'CardsPicker',
  components: {
    PokerCard,
  },
  mixins: [float_mix],
  props: {
    // value: String,
    cards: Array,
    board: String,
    visible: { default: 5 },
    hasRandomize: Boolean,
    cardSize: { default: 'large' },
    hasClearCards: Boolean,
    lockedIndexes: { default: () => [] },
    disabled: Boolean,
    tstPrefix: { default: () => 'cp' },
    // hasArrows: Boolean,
  },
  emits: ['update:cards', 'input', 'update:board'],
  data() {
    return {
      l_cards: [],
      activeArrow: '',
      arrTimeout: 0,
    }
  },
  methods: {
    randomize() {
      const cards = this.l_cards
      const lockedIndexes = this.lockedIndexes || []
      const options = getAllCards()

      let conf = cards.map((cc, idx) => ({
        id: cc,
        replace: lockedIndexes.includes(idx) ? false : cc.includes('E'),
      }))
      if (conf.every(i => !i.replace)) {
        conf = conf.map((i, idx) => ({
          ...i,
          replace: !lockedIndexes.includes(idx),
        }))
      }

      const dontReplaceOptions = conf.filter(i => !i.replace).map(i => i.id)
      const replaceOptions = conf.filter(i => i.replace)

      const newCards = []
      replaceOptions.forEach(_ => {
        const card = getRandomOptions({
          options,
          selected: [
            ...dontReplaceOptions, //
            ...newCards,
          ],
        })
        newCards.push(card)
      })

      const res = conf.map((cc, idx) => (cc.replace ? newCards.shift() : cc.id))
      this.emitUpdate(res, 'randomized')

      // --dev only test
      // if (res.some((cc, idx) => res.some((ccc, cIdx) => cc === ccc && idx !== cIdx))) {
      //   debugger
      // }
      // this.l_cards = res
      // this.randomize()
    },
    initialize(cards) {
      // console.log(cards)
      this.l_cards = [...cards, 'E0', 'E2', 'E3', 'E4', 'E5'].slice(0, this.visible)
    },
    toogle(card, trigger = 'click') {
      if (this.lockedCards.includes(card)) return

      let res = null
      const switchIndex = this.l_cards.findIndex(id => id === card)
      if (switchIndex !== -1) {
        res = this.l_cards.map((id, idx) => (switchIndex === idx ? `E${idx}` : id))
      } else {
        if (this.selected === this.visible) {
          return
        }
        const idx = this.l_cards.findIndex(c => c.includes('E'))
        res = this.l_cards.map((id, i) => (idx === i ? card : id))
      }

      this.l_cards = res
      this.emitUpdate(res, trigger)
    },
    clear() {
      this.l_cards = this.l_cards.map((cc, idx) =>
        this.lockedIndexes.includes(idx) ? cc : `E${idx}`,
      )
      this.emitUpdate(this.l_cards, 'clear')
    },
    emitUpdate(cards, trigger, force) {
      if (this.disabled && !force) return

      this.$emit('update:cards', { cards, trigger })
      this.$emit('input', cards.join(''))

      const board = getValidBoard(cards.join(''))
      if (board || cards.every(i => i.includes('E'))) {
        this.$emit('update:board', board)
      }
    },
  },
  computed: {
    cardRows() {
      const rows = getCardRows()
      return rows.map(row =>
        row.map(card => ({
          id: card,
          locked: this.lockedCards.includes(card),
          selected: this.l_cards.some(id => id === card),
        })),
      )
    },
    selected() {
      const cards = this.l_cards.slice(0, this.visible)
      return cards.filter(c => !c.includes('E')).length
    },
    valueProp() {
      const res = this.cards ? this.cards : getCardsFromStr(this.board || '')
      return res
    },
    screen_max440() {
      return this.$store.getters.screen_max440
    },
    cardVisual() {
      const { cardTheme, cardBack } = this.$store.getters.mergedUserSettings
      return {
        cardTheme,
        cardBack,
      }
    },
    visibleCards() {
      return this.l_cards.filter((i, index) => index <= this.visible - 1)
    },
    lockedCards() {
      return this.lockedIndexes.map(idx => this.l_cards[idx])
    },
    isDev() {
      // return import.meta.env.VITE_ENV === 'production'
      // ? import.meta.env.VITE_BRANCH !== 'master' : true
      return import.meta.env.VITE_ENV !== 'production'
    },
  },
  watch: {
    valueProp: {
      immediate: true,
      handler: 'initialize',
    },
  },
}
</script>
<style lang="scss" scoped>
.brdpckr {
  display: flex;
  flex-direction: column;
  position: relative;
  &_cards {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    padding-bottom: 2px;
    &:after {
      content: '';
      background: var(--clr-primary);
      width: 100%;
      height: 2px;
      border-radius: 99px;
      position: absolute;
      bottom: 0;
      left: 0;
    }
    flex-shrink: 0;
    margin: 0 auto 0 0;
    position: relative;
    &_card {
      &:last-child {
        margin: 0 !important;
      }
    }
  }
  &_cards-rows {
    display: flex;
    flex-direction: column;
    margin: 1rem 0 0 0;
    &_row {
      display: flex;
      &_card {
        margin-bottom: 2px;
      }
    }
  }
  &_randomize {
    position: absolute;
    left: calc(100% + 1rem);
    bottom: 0;
    z-index: 2;
  }
  &_clear {
    position: absolute;
    right: -2em;
    top: 0;
  }
}

@media (max-width: 1023px) {
  .brdpckr {
    &_cards-rows {
      &_row {
        flex-wrap: wrap;
      }
    }
  }
}
</style>
